import { type TranslationTree } from '@/i18n/types';

export const messages = {
  position: 'Botão {{n}}',
  moveUp: 'Passar para primeiro',
  remove: 'Remover botão',
  optional: 'opcional',
  url: 'Link',
  urlHint: 'Site, loja ou página de inscrição.',
  whatsappNumber: 'WhatsApp com DDD',
  message: 'Mensagem inicial',
  messageHint:
    'Vazia, a conversa abre com a mensagem acima, que mostra que o contato veio do Bodyprint.',
  phoneNumber: 'Telefone com DDD',
  phoneHint: 'Fixo, celular ou 0800.',
  leadHint:
    'O atleta aceita compartilhar nome, e-mail e telefone. Os contatos aparecem em Resultados, com a data e o texto exato que cada um aceitou.',
  directionsHint:
    'Abre o mapa até o endereço de "Onde vale". Com mais de um local, o atleta escolhe qual.',
  label: 'Texto do botão',
  labelHint: 'Vazio, o botão usa o texto sugerido.',
} satisfies TranslationTree;
